export const taskIcons = {
    doNode: require('./images/tasktypes/do_2color.png'),
    checklistNode: require('./images/tasktypes/fetch_2color.png'),
    waitNode: require('./images/tasktypes/wait_2color.png'),
    decideNode: require('./images/tasktypes/decide_2color.png')
}

export const logos = [
    require('./icons/logo_studio_blue.png'),
    require('./icons/logo_studio_green.png'),
    require('./icons/logo_studio_yellow.png'),
    require('./icons/logo_studio_orange.png'),
    require('./icons/logo_studio_red.png'),
]

export const inaPattern = require('./images/ina_studio_login.png')

export const inaLogo = require('./images/ina_studio_mask.png')

export const inaBack = require('./images/ina_studio_back.png')

export const placeholderImg = require('./images/placeholder.png')

export const loadingImg = require("./images/loading.png")